import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { UnauthorizedComponent } from './core/unauthorized/unauthorized.component';
import { WithoutPermissionComponent } from './core/without-permission/without-permission.component';
import { NotFoundComponent } from './core/not-found/not-found.component';
import { AuthenticationComponent } from './core/authentication/authentication.component';

export const routes: Routes = [
  { path: '', component: AuthenticationComponent, pathMatch: 'full' },
  { path: 'pages', loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule) },
  { path: 'unauthorized/:errorCode', component: UnauthorizedComponent, pathMatch: 'full' },
  { path: 'unauthorized', component: UnauthorizedComponent, pathMatch: 'full' },
  { path: 'without-permission', component: WithoutPermissionComponent, pathMatch: 'full' },
  { path: '**', component: NotFoundComponent }
];

export const routing: ModuleWithProviders = RouterModule.forRoot(routes, {
  preloadingStrategy: PreloadAllModules, useHash: true
});
